import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useContentful from "../../../hooks/useContentfull";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import "./Blog_Details.css";
import { Alert, Avatar } from "@mui/material";
import Spinner from "../../../components/Ui/Spinner/Spinner";


const BlogDetails = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { getPostBySlug } = useContentful();

    useEffect(() => {
        const fetchPost = async () => {
            try {
                setLoading(true);
                const postData = await getPostBySlug(slug);
                setPost(postData);
            } catch (err) {
                console.error("Error fetching post:", err);
                setError("Failed to load this article. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [slug]);

    return (
        <div className="blog-details container">
            {loading ? (
                <Spinner />
            ) : error ? (
                <div className="error-message">
                    <Alert severity="error">{error}</Alert>
                </div>
            ) : !post ? (
                <div className="empty-message">
                    <p>Post not found</p>
                </div>
            ) : (
                <article>
                    {/* Header Image */}
                    {post.headerImage && (
                        <div className="blog-details-image">
                            <img src={post.headerImage} alt={post.title} />
                        </div>
                    )}

                    <div className="blog-details-content">
                        {/* Date */}
                        <div className="blog-details-date-container">
                            <span className="blog-details-date">
                                Published on{" "}
                                {new Date(post.publicationDate).toLocaleDateString()}
                            </span>
                        </div>

                        {/* Author */}
                        <div className="blog-details-author">
                            {post.author?.profilePicture ? (
                                <img
                                    src={post.author.profilePicture}
                                    alt={post.author.name}
                                    className="blog-details-author-image"
                                />
                            ) : (
                                <Avatar sx={{ width: 50, height: 50 }}>
                                    {post.author?.name?.charAt(0) || "?"}
                                </Avatar>
                            )}
                            <span className="blog-details-author-name">
                                {post.author?.name}
                            </span>
                        </div>

                        <h1 className="blog-details-title">{post.title}</h1>

                        {/* Body */}
                        <div className="blog-details-body">
                            {post.body && documentToReactComponents(post.body)}
                        </div>
                    </div>
                </article>
            )}
        </div>
    );
};

export default BlogDetails;
